import React, { useState, useEffect, useContext } from 'react';
import { Container } from 'react-bootstrap';
import { Menu, Bell, Search } from 'lucide-react';
import '../../assets/styles/admin/AdminMasterLayout.css';
import AdminSidebar from '../../components/admin/adminSidebar/AdminSidebar';
import { useNavigate } from 'react-router-dom';
import AppContext from '../../context/AppContext';


const AdminMasterLayout = ({ children }) => {
  const navigate = useNavigate();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const {storeLoggedInAdmin} = useContext(AppContext);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 992) {
        setIsSidebarCollapsed(false);
      }
       storeLoggedInAdmin(JSON.parse(localStorage.getItem("admin")));
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarCollapsed(!isSidebarCollapsed);
    }
  };

  const toggleMobileSidebar = () => {
    setIsMobileSidebarOpen(!isMobileSidebarOpen);
  };

  return (
    <div className="adminmasterlayout-wrapper">
      
      {/* Sidebar */}
      <div className={isMobileSidebarOpen ? 'adminmasterlayout-sidebar-mobile-open' : ''}>
        <AdminSidebar 
          isCollapsed={isSidebarCollapsed} 
          toggleSidebar={toggleSidebar}
        />
      </div>

      {/* Overlay */}
      {isMobileSidebarOpen && (
        <div 
          className="adminmasterlayout-mobile-overlay"
          onClick={toggleMobileSidebar}
        ></div>
      )}

      {/* Main Area */}
      <div className={`adminmasterlayout-main ${
        isSidebarCollapsed ? 'adminmasterlayout-main-expanded' : ''
      }`}>
        
        {/* Header */}
        <header className="adminmasterlayout-header">
          <Container fluid>
            <div className="adminmasterlayout-header-content">
              
              <div className="adminmasterlayout-header-left">
                <button 
                  className="adminmasterlayout-mobile-menu-btn"
                  onClick={toggleMobileSidebar}
                >
                  <Menu size={24} />
                </button>

                <div className="adminmasterlayout-search-wrapper">
                  {/* ✅ FIX 1: className add ki — icon ab absolute position pe rahega */}
                  <Search size={16} className="adminmasterlayout-search-icon" />
                  {/* ✅ FIX 2: className add ki — CSS ki padding aur styling apply hogi */}
                  <input
                    type="text"
                    className="adminmasterlayout-search-input"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>
              </div>

              <div className="adminmasterlayout-header-right">
                <button className="adminmasterlayout-notification-btn">
                  <Bell size={20} />
                  <span className="adminmasterlayout-notification-badge">5</span>
                </button>

                <div className="adminmasterlayout-user-profile">
                  <div className="adminmasterlayout-user-avatar">
                    <span onClick={() => navigate('/admin/settings')}>A</span>
                  </div>
                  <div className="adminmasterlayout-user-info">
                    <div className="adminmasterlayout-user-name">Admin User</div>
                    <small className="adminmasterlayout-user-role">Super Admin</small>
                  </div>
                </div>
              </div>

            </div>
          </Container>
        </header>

        {/* Content */}
        <main className="adminmasterlayout-content">
          <Container fluid>
            {children}
          </Container>
        </main>

      </div>
    </div>
  );
};

export default AdminMasterLayout;